import type { GetItemPropsOptions } from 'downshift'
import Downshift from 'downshift'
import type { ReactNode } from 'react'
import { Children } from 'react'
import classes from './TruncatedItemList.module.scss'
import PopOut from '../PopOut/PopOut'

interface Props {
  children: ReactNode
  expandedLabel?: ReactNode
  maxCollapsedWidth?: number
  maxExpandedWidth?: number
}

const renderChild = (child: ReactNode, index: number, getItemProps: (options: GetItemPropsOptions<any>) => any) =>
  <div
    {
      ...getItemProps({
        item: child,
        index,
        key: index
      })
    }
  >
    {child}
  </div>

const renderButton = ( isOpen: boolean, buttonProps: any, ref?: any, onClick?: any,expandedLabel?: ReactNode) =>
  <button
    aria-label='open actions menu'
    className={classes.TruncatedPopOutItemListButton}
    {...buttonProps}
    aria-expanded={
      isOpen
        ? 'true'
        : 'false'
    }
    onClick={onClick}
    ref={ref}
    title={
      isOpen
        ? 'Collapse'
        : 'Expand'
    }
    type='button'
  >
    {
      isOpen
        ? expandedLabel
        : '\u2026' // ellipses
    }
  </button>

const TruncatedPopOutItemList = ({
  expandedLabel = 'Hide',
  children,
  maxCollapsedWidth,
  maxExpandedWidth
}: Props) =>
  <Downshift>
    {
      ({
        getToggleButtonProps,
        getMenuProps,
        getItemProps
      }) =>
        <div
          className={classes.TruncatedItemList}
          style={{ maxWidth: maxCollapsedWidth }}
        >
          <PopOut
            placement='bottom-start'
            trigger={(ref, onClick, isOpen) => renderButton(isOpen || false, getToggleButtonProps, ref, onClick, expandedLabel)}
          >
            <div
              className={classes.TruncatedPopOutItemListOptions}
              style={{ maxWidth: maxExpandedWidth }}
              tabIndex={-1}
            >
              {
                Children.map(
                  children,
                  (child, index) =>
                    renderChild(child, index, getItemProps)
                )
              }
            </div>
          </PopOut>
          <div
            {...getMenuProps()}
            style={{ maxWidth: maxExpandedWidth }}
            tabIndex={-1} // prevent focus trap when items are not visible
          >
            {
              Children.map(
                children,
                (child, index) =>
                  renderChild(child, index, getItemProps)
              )
            }
          </div>
        </div>
    }
  </Downshift>

export default TruncatedPopOutItemList
